<template>
  <NuxtImg
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :loading="loading"
    :style="style"
    :format="format"
    v-bind="$attrs"
    @error="onError"
  />
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  interface Props {
    src: string | undefined;
    alt: string;
    width?: string | number | undefined;
    height?: string | number | undefined;
    loading?: 'lazy' | 'eager';
    style?: Record<string, string>;
    format?: 'svg' | 'webp' | 'avif' | 'png' | 'jpg' | 'jpeg' | 'gif';
    placeholder?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    loading: 'eager',
    format: undefined,
    style: () => ({}),
    width: undefined,
    height: undefined,
    placeholder: undefined
  });

  const src = ref<string | undefined>(props.src);

  const onError = () => {
    src.value = props.placeholder;
  };
</script>
